$(document).ready(function(){


    $( '.slick-slideshow' ).slick(
    {
        arrows: false,
        dots: true,
        infinite: false,
        adaptiveHeight: true
    });


    $('.slick-slideshow2').slick({
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        arrows: false,
        dots: true,
        infinite: false
    });

    $('.slick-thumbnail').slick(
    {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slick-thumbnail-choice'
    });

    $('.slick-thumbnail-choice').slick(
    {
        slidesToShow: 8,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.slick-thumbnail',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.slick-posts').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

});